/* ══════════════════════════════════════════════════════════════════
   HobbyChef — našeptávač hledání (predictive search)

   Připojí se ke KAŽDÉMU poli s atributem data-hc-predictive:
     · pole na /search (sections/hc-search.liquid),
     · pole v rozbalovacím pruhu hlavičky (desktop, lupa),
     · pole v mobilním panelu (data-hc-predictive="inline" — výsledky
       se vysázejí pod pole do toku panelu, ne jako plovoucí nabídka).

   ZDROJ DAT: /search/suggest.json (Shopify Predictive Search).
   Proč JSON, a ne Section Rendering (/search/suggest?section_id=…):
     · JSON nese u produktu štítky (tags), takže skryté služby lze
       spolehlivě vyřadit tady — viz SKRYTÉ POLOŽKY,
     · ceny přicházejí v měně návštěvníka (ověřeno 22. 9. 2026: v EUR
       vrací 407.95 místo 9990.00), formát ceny se bere ze vzoru, který
       hlavička vysází filtrem | money (data-hc-money),
     · nepotřebuje další sekci v themu a jde ověřit na živém obchodě
       vložením skriptu, bez nasazení.

   SKRYTÉ POLOŽKY (štítek skryta-polozka: gravírování, dárkové pouzdro)
   se do nabídky nesmí dostat. Suggest sice přívěsek -tag:skryta-polozka
   „umí“, ale mění tím i shody: „ya“ dalo s přívěskem 1 produkt místo 7
   a „sa“ přišlo o kategorie (změřeno 22. 9. 2026). Dotaz proto jde bez
   přívěsku a skryté produkty se vyřadí podle štítků tady. Plné hledání
   (odeslání formuláře) přívěsek nese dál, přesně podle CLAUDE.md §23.

   VOLNÉ SHODY. Suggest vrací na nesmyslný dotaz i nesouvisející zboží
   („xyzxyz“ → Dárkový poukaz YAXELL). Položka proto zůstane jen tehdy,
   když její text obsahuje začátek (3 znaky) aspoň jednoho slova dotazu,
   bez ohledu na diakritiku — překlep „santku“ projde, „xyzxyz“ ne.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var HIDDEN_TAG = 'skryta-polozka';
  var HIDDEN_FILTER = '-tag:skryta-polozka';
  var MIN_CHARS = 2;
  var DEBOUNCE = 200;
  var MAX = { products: 6, collections: 4, articles: 3, pages: 3 };
  var DESKTOP = window.matchMedia('(min-width: 1100px)');

  var uid = 0;

  /* ── Pomocné ─────────────────────────────────────────────────────── */

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* „Pánev“ → „panev“: porovnání bez diakritiky a velikosti písmen. */
  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  function stripHtml(s) {
    return String(s || '').replace(/<[^>]*>/g, ' ');
  }

  function suggestUrl() {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + 'search/suggest.json';
  }

  /* ── Cena ────────────────────────────────────────────────────────────
     Hlavička vysází data-hc-money="{{ 123456789 | money }}" — tedy vzor
     v aktuální měně a formátu obchodu („1 234 568 Kč“, „€1.234.567,89“).
     Z něj se vyčte předpona, přípona, oddělovač tisíců a desetinná místa. */
  var money = null;
  function moneyFormat() {
    if (money) return money;
    var holder = document.querySelector('[data-hc-money]');
    var sample = holder ? holder.getAttribute('data-hc-money') : '';
    var m = sample && sample.match(/\d[\d\s.,'\u00a0\u202f]*\d/);
    if (m) {
      var num = m[0];
      var dec = num.match(/([.,])(\d{2})$/);
      var thou = /\d/.test(num.charAt(1)) ? '' : num.charAt(1);
      money = {
        pre: sample.slice(0, m.index),
        post: sample.slice(m.index + num.length),
        decimals: dec && dec[2] === '89' ? 2 : 0,
        decSep: dec ? dec[1] : ',',
        thou: thou
      };
    } else {
      money = { intl: true };
    }
    return money;
  }

  function formatMoney(amount) {
    var value = parseFloat(amount);
    if (isNaN(value)) return '';
    var f = moneyFormat();
    if (f.intl) {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CZK';
      try {
        return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: cur, maximumFractionDigits: cur === 'CZK' ? 0 : 2 }).format(value);
      } catch (e) { return String(value); }
    }
    var fixed = value.toFixed(f.decimals).split('.');
    var int = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.thou);
    return f.pre + int + (f.decimals ? f.decSep + fixed[1] : '') + f.post;
  }

  /* Náhled z CDN Shopify v potřebné šířce (retina 2×). */
  function thumb(url, width) {
    if (!url) return '';
    try {
      var u = new URL(url, location.href);
      u.searchParams.set('width', width);
      return u.toString();
    } catch (e) { return url; }
  }

  /* ── Data ─────────────────────────────────────────────────────────── */

  var cache = {};

  function relevant(words, text) {
    if (!words.length) return true;
    var hay = norm(text);
    for (var i = 0; i < words.length; i++) {
      if (hay.indexOf(words[i]) !== -1) return true;
    }
    return false;
  }

  function prepare(json, q) {
    var r = (json && json.resources && json.resources.results) || {};
    /* Začátky slov dotazu (3 znaky, u kratších slov celé slovo). */
    var words = norm(q).split(/\s+/).filter(Boolean).map(function (w) { return w.slice(0, 3); });
    /* Kód zboží (aspoň 4 znaky s číslicí, např. „36644“): Shopify produkt
       našel podle SKU, jenže suggest.json vrací prázdné `variants`, takže
       by ho filtr shody níž vždycky zahodil. U takového dotazu se produktům
       věří tak, jak je Shopify vrátil (skryté služby se vyřazují dál). */
    var isCode = norm(q).split(/\s+/).some(function (w) { return w.length >= 4 && /\d/.test(w); });

    var products = (r.products || []).filter(function (p) {
      var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
      if (tags.indexOf(HIDDEN_TAG) !== -1) return false;
      if (isCode) return true;
      var variants = (p.variants || []).map(function (v) { return (v.title || '') + ' ' + (v.sku || ''); }).join(' ');
      return relevant(words, [p.title, p.vendor, p.type, tags.join(' '), stripHtml(p.body), variants].join(' '));
    }).slice(0, MAX.products);

    function simple(list, max) {
      return (list || []).filter(function (x) {
        return relevant(words, [x.title, stripHtml(x.body), stripHtml(x.summary_html), (x.tags || []).join(' ')].join(' '));
      }).slice(0, max);
    }

    return {
      products: products,
      collections: simple(r.collections, MAX.collections),
      articles: simple(r.articles, MAX.articles),
      pages: simple(r.pages, MAX.pages)
    };
  }

  function fetchSuggest(q, signal) {
    var key = norm(q);
    if (cache[key]) return Promise.resolve(cache[key]);
    var params = new URLSearchParams();
    params.set('q', q);
    params.set('resources[type]', 'product,collection,article,page');
    /* Rezerva nad 6 produktů na skryté položky a volné shody. */
    params.set('resources[limit]', '10');
    params.set('resources[limit_scope]', 'each');
    return fetch(suggestUrl() + '?' + params.toString(), {
      signal: signal,
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('suggest ' + res.status);
      return res.json();
    }).then(function (json) {
      var data = prepare(json, q);
      cache[key] = data;
      return data;
    });
  }

  /* ── Jedno pole s nabídkou ───────────────────────────────────────── */

  function Predictive(input) {
    this.input = input;
    this.form = input.closest('form');
    this.inline = input.getAttribute('data-hc-predictive') === 'inline';
    this.id = 'hc-pred-' + (++uid);
    this.items = [];
    this.active = -1;
    this.timer = null;
    this.ctrl = null;
    this.lastQ = '';
    this.build();
    this.bind();
  }

  Predictive.prototype.build = function () {
    var panel = el('div', 'hc-pred' + (this.inline ? ' hc-pred--inline' : ''));
    panel.id = this.id;
    panel.hidden = true;

    this.list = el('div', 'hc-pred__list');
    this.list.id = this.id + '-list';
    this.list.setAttribute('role', 'listbox');
    this.list.setAttribute('aria-label', 'Návrhy hledání');
    panel.appendChild(this.list);

    /* Počet návrhů pro čtečky obrazovky. */
    this.live = el('p', 'hc-pred__sr');
    this.live.setAttribute('role', 'status');
    this.live.setAttribute('aria-live', 'polite');
    panel.appendChild(this.live);

    this.panel = panel;

    if (this.inline) {
      /* Mobilní panel: výsledky do toku hned pod formulář. */
      var anchor = this.form || this.input;
      anchor.parentNode.insertBefore(panel, anchor.nextSibling);
    } else {
      /* Plovoucí nabídka pod formulářem (celou jeho šířkou, i s tlačítkem). */
      var host = this.form || this.input.parentNode;
      host.classList.add('hc-pred-host');
      host.appendChild(panel);
    }

    var i = this.input;
    i.setAttribute('role', 'combobox');
    i.setAttribute('aria-autocomplete', 'list');
    i.setAttribute('aria-expanded', 'false');
    i.setAttribute('aria-controls', this.list.id);
    i.setAttribute('autocomplete', 'off');
  };

  Predictive.prototype.bind = function () {
    var self = this;
    var input = this.input;

    input.addEventListener('input', function () { self.schedule(); });
    input.addEventListener('focus', function () {
      if (self.value().length >= MIN_CHARS && self.list.childNodes.length) self.open();
    });
    input.addEventListener('keydown', function (e) { self.onKey(e); });

    /* Klik na položku: najetí myší jen zvýrazní, odkaz vede sám. */
    this.list.addEventListener('mousemove', function (e) {
      var opt = e.target.closest('[role="option"]');
      if (!opt) return;
      var idx = self.items.indexOf(opt);
      if (idx !== -1 && idx !== self.active) self.highlight(idx, false);
    });
    this.list.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-hc-pred-all]');
      if (!opt) return;
      e.preventDefault();
      self.submit();
    });

    /* Klik nebo dotyk mimo pole a nabídku zavře. */
    document.addEventListener('pointerdown', function (e) {
      if (self.panel.hidden) return;
      var t = e.target;
      if (self.panel.contains(t) || t === input || (self.form && self.form.contains(t))) return;
      self.close();
    });

    /* Tabulátorem pryč = zavřít. relatedTarget null (klik na odkaz
       v Safari) se ignoruje, jinak by nabídka zmizela dřív než klik. */
    var scope = this.inline ? this.panel.parentNode : (this.form || input.parentNode);
    scope.addEventListener('focusout', function (e) {
      var to = e.relatedTarget;
      if (!to) return;
      if (self.panel.contains(to) || to === input || (self.form && self.form.contains(to))) return;
      self.close();
    });

    /* Plné hledání vždy s přívěskem (CLAUDE.md §23). Hlídá duplicitu,
       takže nevadí, že stejnou věc dělá i formulář na /search a v panelu. */
    if (this.form && !this.form.hasAttribute('data-hc-pred-bound')) {
      this.form.setAttribute('data-hc-pred-bound', '');
      this.form.addEventListener('submit', function () {
        var v = input.value.trim();
        if (v && v.indexOf(HIDDEN_TAG) === -1) input.value = v + ' ' + HIDDEN_FILTER;
      });
    }
  };

  Predictive.prototype.value = function () {
    return this.input.value.replace(HIDDEN_FILTER, '').trim();
  };

  Predictive.prototype.schedule = function () {
    var self = this;
    clearTimeout(this.timer);
    var q = this.value();
    if (q.length < MIN_CHARS) {
      if (this.ctrl) this.ctrl.abort();
      this.lastQ = '';
      this.clear();
      this.close();
      return;
    }
    this.timer = setTimeout(function () { self.run(q); }, DEBOUNCE);
  };

  Predictive.prototype.run = function (q) {
    var self = this;
    if (q === this.lastQ && !this.panel.hidden) return;
    if (this.ctrl) this.ctrl.abort();
    var ctrl = window.AbortController ? new AbortController() : null;
    this.ctrl = ctrl;
    this.panel.setAttribute('aria-busy', 'true');
    fetchSuggest(q, ctrl ? ctrl.signal : undefined).then(function (data) {
      if (ctrl !== self.ctrl || self.value() !== q) return;
      self.lastQ = q;
      self.render(data, q);
      self.open();
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      /* Síť selhala: nabídka se nezobrazí, formulář funguje dál. */
      self.close();
    }).then(function () {
      if (ctrl === self.ctrl) self.panel.removeAttribute('aria-busy');
    });
  };

  /* ── Vykreslení ───────────────────────────────────────────────────── */

  Predictive.prototype.clear = function () {
    this.list.textContent = '';
    this.items = [];
    this.active = -1;
    this.input.removeAttribute('aria-activedescendant');
  };

  Predictive.prototype.option = function (href, cls) {
    var li = el('div', 'hc-pred__opt' + (cls ? ' ' + cls : ''));
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');
    li.id = this.id + '-o' + this.items.length;
    var a = el('a', 'hc-pred__link');
    a.href = href;
    a.tabIndex = -1;
    li.appendChild(a);
    this.items.push(li);
    return { li: li, a: a };
  };

  Predictive.prototype.group = function (title) {
    var wrap = el('div', 'hc-pred__group');
    var h = el('p', 'hc-pred__h', title);
    h.setAttribute('aria-hidden', 'true');
    var g = el('div', 'hc-pred__opts');
    g.setAttribute('role', 'group');
    g.setAttribute('aria-label', title);
    wrap.appendChild(h);
    wrap.appendChild(g);
    this.list.appendChild(wrap);
    return g;
  };

  Predictive.prototype.render = function (data, q) {
    var self = this;
    this.clear();
    var count = data.products.length + data.collections.length + data.articles.length + data.pages.length;

    if (data.products.length) {
      var gp = this.group('Produkty');
      data.products.forEach(function (p) {
        var o = self.option(p.url, 'hc-pred__opt--prod');
        var media = el('span', 'hc-pred__media');
        var src = p.featured_image && p.featured_image.url || p.image;
        if (src) {
          var img = el('img');
          img.src = thumb(src, 112);
          img.alt = '';
          img.width = 56;
          img.height = 56;
          img.loading = 'lazy';
          media.appendChild(img);
        }
        var body = el('span', 'hc-pred__body');
        body.appendChild(el('span', 'hc-pred__title', p.title));
        var price = el('span', 'hc-pred__price');
        var was = parseFloat(p.compare_at_price_max);
        var now = parseFloat(p.price);
        if (was > now) price.appendChild(el('s', 'hc-pred__was', formatMoney(was)));
        price.appendChild(document.createTextNode(formatMoney(now)));
        body.appendChild(price);
        o.a.appendChild(media);
        o.a.appendChild(body);
        gp.appendChild(o.li);
      });
    }

    [['collections', 'Kategorie'], ['articles', 'Články'], ['pages', 'Stránky']].forEach(function (pair) {
      var list = data[pair[0]];
      if (!list.length) return;
      var g = self.group(pair[1]);
      list.forEach(function (x) {
        var o = self.option(x.url, 'hc-pred__opt--text');
        o.a.textContent = x.title;
        g.appendChild(o.li);
      });
    });

    if (!count) {
      var empty = el('p', 'hc-pred__empty');
      empty.appendChild(document.createTextNode('Pro „' + q + '“ jsme nic nenašli. Zkuste jiné slovo, nebo prohledejte celý obchod.'));
      this.list.appendChild(empty);
    }

    /* Poslední řádek: plné hledání (odešle formulář i s přívěskem). */
    var all = this.option(this.fullUrl(q), 'hc-pred__opt--all');
    all.li.setAttribute('data-hc-pred-all', '');
    all.a.textContent = count ? 'Zobrazit všechny výsledky pro „' + q + '“' : 'Prohledat celý obchod';
    var foot = el('div', 'hc-pred__foot');
    foot.appendChild(all.li);
    this.list.appendChild(foot);

    this.live.textContent = count
      ? (count === 1 ? '1 návrh' : count < 5 ? count + ' návrhy' : count + ' návrhů') + ', šipkami vyberete.'
      : 'Žádné návrhy.';
  };

  Predictive.prototype.fullUrl = function (q) {
    var action = (this.form && this.form.getAttribute('action')) || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'search';
    return action + '?q=' + encodeURIComponent(q + ' ' + HIDDEN_FILTER);
  };

  Predictive.prototype.submit = function () {
    if (this.form) {
      if (this.form.requestSubmit) this.form.requestSubmit();
      else { this.form.dispatchEvent(new Event('submit', { cancelable: true })); this.form.submit(); }
    } else {
      location.href = this.fullUrl(this.value());
    }
  };

  /* ── Otevření, zvýraznění, klávesnice ─────────────────────────────── */

  Predictive.prototype.open = function () {
    if (!this.list.childNodes.length) return;
    this.panel.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
  };

  Predictive.prototype.close = function () {
    clearTimeout(this.timer);
    this.panel.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    this.highlight(-1);
  };

  Predictive.prototype.isOpen = function () { return !this.panel.hidden; };

  Predictive.prototype.highlight = function (idx, scroll) {
    if (this.active > -1 && this.items[this.active]) {
      this.items[this.active].classList.remove('is-active');
      this.items[this.active].setAttribute('aria-selected', 'false');
    }
    this.active = idx;
    if (idx < 0 || !this.items[idx]) {
      this.active = -1;
      this.input.removeAttribute('aria-activedescendant');
      return;
    }
    var opt = this.items[idx];
    opt.classList.add('is-active');
    opt.setAttribute('aria-selected', 'true');
    this.input.setAttribute('aria-activedescendant', opt.id);
    if (scroll !== false) opt.scrollIntoView({ block: 'nearest' });
  };

  Predictive.prototype.onKey = function (e) {
    var n = this.items.length;
    switch (e.key) {
      case 'ArrowDown':
        if (!n) return;
        e.preventDefault();
        if (!this.isOpen()) { this.open(); return; }
        this.highlight(this.active + 1 >= n ? 0 : this.active + 1);
        break;
      case 'ArrowUp':
        if (!n || !this.isOpen()) return;
        e.preventDefault();
        this.highlight(this.active <= 0 ? n - 1 : this.active - 1);
        break;
      case 'Enter':
        if (!this.isOpen() || this.active < 0) return; /* odešle formulář */
        e.preventDefault();
        var opt = this.items[this.active];
        if (opt.hasAttribute('data-hc-pred-all')) { this.submit(); return; }
        var a = opt.querySelector('a');
        if (a) location.href = a.href;
        break;
      case 'Escape':
        if (this.isOpen()) {
          e.preventDefault();
          e.stopPropagation(); /* nezavírat zároveň mobilní panel / pruh */
          this.close();
        }
        break;
    }
  };

  /* ── Pruh hledání v hlavičce (desktop) ────────────────────────────────
     Lupa je odkaz na /search — bez JS vede tam. Se skriptem na desktopu
     otevře pruh přes světlou lištu kategorií; pod 1100 px otevře mobilní
     panel a skočí do jeho pole hledání. Na /search jen skočí do pole
     stránky, druhé pole by tam bylo navíc. */
  function initHeaderSearch() {
    var btn = document.querySelector('[data-hc-hsearch-open]');
    var bar = document.getElementById('hc-hsearch');
    if (!btn) return;
    var input = bar && bar.querySelector('input[name="q"]');

    function openBar() {
      bar.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      input.focus();
      input.select();
    }
    function closeBar(focusBtn) {
      if (!bar || bar.hidden) return;
      bar.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (input && input._hcPred) input._hcPred.close();
      if (focusBtn) btn.focus();
    }

    btn.addEventListener('click', function (e) {
      var page = document.querySelector('[data-hc-search-input]');
      if (DESKTOP.matches) {
        if (page) {
          e.preventDefault();
          page.focus();
          page.scrollIntoView({ block: 'center' });
          return;
        }
        if (!bar || !input) return;
        e.preventDefault();
        if (bar.hidden) openBar(); else closeBar(true);
        return;
      }
      var burger = document.querySelector('[data-hc-drawer-open]');
      var drawerInput = document.querySelector('#hc-drawer input[name="q"]');
      if (!burger || !drawerInput) return;
      e.preventDefault();
      burger.click();
      drawerInput.focus();
    });

    if (!bar) return;
    var closeBtn = bar.querySelector('[data-hc-hsearch-close]');
    if (closeBtn) closeBtn.addEventListener('click', function () { closeBar(true); });

    /* Esc v pruhu: nejdřív zavře nabídku (řeší Predictive), pak pruh. */
    bar.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeBar(true);
    });
    document.addEventListener('pointerdown', function (e) {
      if (bar.hidden) return;
      if (bar.contains(e.target) || btn.contains(e.target)) return;
      closeBar(false);
    });
    /* Zmenšení okna pod 1100 px: pruh tam není, zavřít. */
    var onMq = function () { if (!DESKTOP.matches) closeBar(false); };
    if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', onMq);
    else if (DESKTOP.addListener) DESKTOP.addListener(onMq);
  }

  function init() {
    var inputs = document.querySelectorAll('input[data-hc-predictive]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i]._hcPred) continue;
      inputs[i]._hcPred = new Predictive(inputs[i]);
    }
    initHeaderSearch();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
